(function () {
  angular.module("akitabox.core.auth.sendValidation", [
    "ui.router",
    "akitabox.core.router",
    "akitabox.core.services.auth",
  ]);
})();
